import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { listDeliveryOrders } from '../../api/delivery';

// Prefers the order object handed off via router state (from DriverHome /
// DriverRideHistory, which already fetched the list) and only re-fetches
// the rider's own runs — there's no single-order GET for the Delivery role —
// as a fallback for a page refresh or direct link.
export function useDriverOrder(orderId) {
  const { user } = useAuth();
  const location = useLocation();
  const stateOrder = location.state?.order?.id === orderId ? location.state.order : null;

  const [order, setOrder] = useState(stateOrder);
  const [loading, setLoading] = useState(!stateOrder);
  const [error, setError] = useState('');

  useEffect(() => {
    if (stateOrder) {
      setOrder(stateOrder);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setError('');
    listDeliveryOrders(undefined, user.idToken)
      .then((list) => {
        if (cancelled) return;
        setOrder(list.find((o) => o.id === orderId) || null);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Could not load this ride.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return { order, setOrder, loading, error };
}
